import React from "react";

const Gap = () => {
  return <div className="empty-details-container"></div>;
};

export default Gap;
